export default "__VITE_ASSET__mjNw4iaT__"